import math from '@/utils/math'

// BaseCellの子コンポーネントから値変換処理を切り出し
export default {
  convertJsonToArray (inputValue, isMultiple) {
    if (isMultiple && !Array.isArray(inputValue)) {
      if (isJSON(inputValue)) {
        return JSON.parse(inputValue)
      } else {
        return []
      }
    } else if (!isMultiple && Array.isArray(inputValue)) {
      return null
    }
  },
  /**
   * valを半角数字の数値に変換し、カンマを削除して返却する.
   * valに数字以外が含まれている場合は、0 を返却する.
   */
  toHalfWidthNumber (val, precision) {
    if (typeof val === 'string' && val.match(/^(?:(?:[-－][０-９\d])|[０-９\d])(?:[.,．，]?[０-９\d]+)*$/) != null) {
      let ret = val
        .replace(/[０-９－．，]/g, char => String.fromCharCode(char.charCodeAt(0) - 0xFEE0))
        .replace(/,/g, '')
      ret = math.floor(
        Number(ret),
        precision || 0)
      return Number.isNaN(ret) ? val : ret
    } else if (val == null || val === undefined) {
      return val
    } else {
      return isNaN(Number(val)) ? 0 : val
    }
  }
}

// JSONかどうか判定
function isJSON (sJSON) {
  try {
    JSON.parse(sJSON)
    return true
  } catch (e) {
    return false
  }
}
